import langRef from 'intLangRef';
import langChi from './lang.zh-hk';
import langEng from './lang.en-us';
import {setNatureComponents} from './langByNature.js';
//var expItem = langRef.lang === 'English' ? langEng : langChi;
//expItem = langChi;
var mixed = getlang(langRef.lang);
export const langReference = langRef;
export default mixed;
export function getLanguage(language){
    return getlang(language);
}

export function getLanguageByNature(opts){
    var lang = getlang(opts.language);
    lang = setNatureComponents(lang,opts);
    return lang;
}


function getlang(language){
    var expItem = language === 'English' ? langEng : langChi;
    //expItem = langChi;
    return {
        lang: langRef.lang,
        navi: expItem.navi,
        register: expItem.register,
        login: expItem.login,
        cart: expItem.cart,
        common: expItem.common,
        contact: expItem.contact,
        order: expItem.order,
        itemDetail: expItem.itemDetail,
        stateLabels: langRef.stateLabels,
        shopsList: expItem.shopsList,
        postList:expItem.postList,
        postEditor:expItem.postEditor,
        postPrices:expItem.postPrices,
        postProps:expItem.postProps,
        postLink:expItem.postLink,
        category:expItem.category
    };
}